import { detectDataAcquisitionType } from "./detect-data-acquisition-type";
import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";

export const processSelectedOurNodes = (
  setLocalArrayFunction,
  setLocalDataAcquisitionType,
  setLocalPollingIntervalInSeconds,
) => {
  const flatSet = getMachineStructureNodeset().selectedNodeIds;

  const flatArrayWithAcquisitionTypes = [];

  const machineStructureFlatMap = getMachineStructureNodeset().getFlatMap();

  flatSet.forEach((nodeId) => {
    const node = machineStructureFlatMap.get(nodeId);
    flatArrayWithAcquisitionTypes.push(node);
  });
  setLocalArrayFunction(flatArrayWithAcquisitionTypes);

  const detectedDataAcquisitionTypeAndInterval = detectDataAcquisitionType(
    flatArrayWithAcquisitionTypes,
  );

  const { type, interval } = detectedDataAcquisitionTypeAndInterval;
  setLocalDataAcquisitionType(type);

  if (typeof interval === "number") {
    setLocalPollingIntervalInSeconds(interval);
  }
};
